module.exports = __webpack_public_path__ + "static/WhenThePastWasAround5-de52a2a4891d31a70a53c90f76118bd5.webp";